import React from "react";
import Button from "../ResubleComp/Button";
import { Link } from "react-router-dom";
const LandingPage = () => {
  const token =
    localStorage.getItem("EXPERT_AUTH_TOKEN") ||
    localStorage.getItem("USER_AUTH_TOKEN");

  return (
    <>
      <div className="my-5 bg-gradient-to-r from-sky-300 to-emerald-100 rounded-lg p-5 lg:mx-44">
        <div className="p-5 text-4xl  text-center  leading-tight  lg:py-24 ">
          <h3 className="lg:text-4xl font-josefin-sans font-bold md:text-4xl text-2xl leading-normal">
            Getting a job and having a great
            <span className="text-green-500"> career</span> are two different
            things. We strive here to build the
            <span className="text-green-500"> latter one</span> for you.
          </h3>
        </div>
      </div>

      {/* ====================who is this for======================== */}
      <div className="px-5 my-60  lg:my-0 lg:mt-44 lg:px-44  w-full justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row-reverse md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center lg:ml-20">
          <br />
          <h1 className="text-2xl lg:text-4xl lg:mb-5 mb-2 font-bold text-center lg:text-left">
            Who is this for?
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            Anyone looking to get better in academics and career. From
            conceptual and technical solutions at any topic in science,
            technology, engineering and mathematics to getting help with
            building real-world projects and products.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 mt-5 flex ">
          <img
            alt="who"
            src="/images/who-is-this-for'.jpg"
            className="w-full rounded-2xl"
          />
        </div>
      </div>

      {/* =================one to one solution section=========================== */}

      <div className="px-5 lg:p-44 w-full mt-10 justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center  lg:mr-20">
          <h1 className="text-2xl mb-2 lg:text-4xl lg:mb-5 font-bold text-center lg:text-left">
            Instant one-to-one solution
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            Practical and high-quality topic-wise solutions for clearing an
            exam, upskilling the most in-demand skills, understanding a subject
            better, and cracking a tech interview round. Get live one-to-one
            solutions to your conceptual, technical and practical problems in an
            instant session in real-time.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 flex justify-center mt-5 lg:mt-0 md:mt-0 ">
          <img
            alt=""
            src="/images/one-to-one.jpg"
            className="w-full rounded-2xl"
          />
        </div>
      </div>

      {/* ===============================mentor section starts here================= */}
      <div className="px-5 py-10 my-60 lg:my-0 lg:px-44 w-full bg-gradient-to-r from-lime-200 to-emerald-400 justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row md:flex-row lg:py-20">
        <div className=" lg:w-1/2 md:w-1/2 flex flex-col justify-center">
          <h1 className="text-2xl mb-5 lg:mb-7 lg:text-4xl font-bold text-center lg:text-left">
            Join in as a Problem Solver
          </h1>
          <div className="flex lg:justify-start justify-center">
            <a href="/problemsolverpage" x>
              <Button className="bg-emerald-400 h-12 text-black text-sm font-semibold px-6 rounded-lg">
                Join Now
              </Button>
            </a>
          </div>
        </div>
        <div className="hidden w-full lg:w-1/2 md:w-1/2 lg:flex justify-center mt-5 lg:mt-0 md:mt-0">
          <img alt="" src="/images/mentor.png" className="w-full" />
        </div>
      </div>

      {/* ===============================job internship section starts here================= */}

      <div className="px-5 mt-10 w-full  font-josefin-sans  lg:pt-40  justify-center items-center text-xl md:text-2xl lg:text-3xl flex flex-col ">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col items-center justify-center">
          <h1 className="text-2xl lg:text-4xl mb-5 font-bold text-center lg:text-left">
            Your favourite topic right here
          </h1>
          <img alt="" src="/images/STEM.jpg" className="w-full" />
        </div>
        <div className="w-full mt-5 lg:w-1/2 md:w-1/2  flex flex-col justify-center items-center">
          <p className="lg:text-lg lg:mt-5 text-center">
            From coding to mathematics to AI to Data Science, you will find
            solutions to every major, practical topic in science, technology,
            engineering and mathematics.
          </p>
        </div>
      </div>

      <div className="px-5 my-60 lg:my-0 lg:mt-10 lg:p-44 w-full justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row-reverse md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center  lg:ml-20">
          <h1 className="text-2xl lg:text-4xl font-bold  lg:mb-5 mb-2 text-center lg:text-left">
            Advanced video session for a smooth experience
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            Join the session with the best video call that will give you an
            advanced in-built tool for the best learning experience, automated
            recording to view after completion of the session and session
            summary instantly after the call so that you stay focused on what's
            important to you.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 flex justify-center mt-5">
          <img
            alt=""
            src="https://images.unsplash.com/photo-1616587226157-48e49175ee20?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
            className="w-full h-5/6 rounded-2xl"
          />
        </div>
      </div>

      <div className="px-5 mt-10 lg:p-44 w-full justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center  lg:mr-20">
          <h1 className="text-2xl lg:text-4xl font-bold  lg:mb-5 mb-2 text-center lg:text-left">
            Price that you will fall in love with
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            Get all of this at the most affordable price that you can imagine.
            Even if you think this is something you cannot afford, you can apply
            for financial aid.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 flex justify-center mt-5 lg:mt-0 md:mt-0">
          <img
            alt=""
            src="/images/pricing.jpg"
            className="w-full  rounded-2xl"
          />
        </div>
      </div>

      <div className="px-5 my-60 lg:my-0 lg:p-44 w-full justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row-reverse md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center  lg:ml-20">
          <h1 className="text-2xl lg:text-4xl font-bold  lg:mb-5 mb-2 text-center lg:text-left">
            Get instant solution powered by Generative AI
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            With MagicAI, get instant solutions in STEM for all your conceptual,
            technical and practical problems. From texts to images to extended
            content, the prompts in the MagicAI are adaptive while providing a
            much better output.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 flex justify-center mt-5 lg:mt-0 md:mt-0">
          <img
            alt=""
            src="/images/poweredbyai.jpg"
            className="w-full rounded-2xl"
          />
        </div>
      </div>

      <div className="px-5 mt-10 lg:p-44 w-full  justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center  lg:mr-20">
          <h1 className="text-2xl lg:text-4xl font-bold  text-center lg:text-left lg:mb-5 mb-2">
            Unlock the possibilities
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            MagicAI can solve difficult STEM problems with greater accuracy,
            thanks to its specific knowledge of topics in the field of STEM and
            problem solving abilities.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 flex justify-center mt-5 lg:mt-0 md:mt-0">
          <img
            alt=""
            src="/images/Generative-AI.png"
            className="w-full rounded-2xl"
          />
        </div>
      </div>

      <div className="px-5 my-60 lg:my-0 lg:p-44 w-full justify-center text-xl md:text-2xl lg:text-3xl flex flex-col lg:flex-row-reverse md:flex-row">
        <div className="w-full lg:w-1/2 md:w-1/2 flex flex-col justify-center  lg:ml-20">
          <h1 className="text-2xl lg:text-4xl font-bold text-center lg:text:left lg:mb-5 mb-2">
            A Personalized experience for you
          </h1>
          <p className="lg:text-lg text-center lg:text-left">
            Get the most out of it with a personalized experience. From
            suggestions to showing you the results, get what matters to you.
          </p>
        </div>
        <div className="w-full lg:w-1/2 md:w-1/2 flex justify-center mt-5 lg:mt-0 md:mt-0">
          <img
            alt=""
            src="/images/generative-ai.jpeg"
            className="w-full rounded-2xl"
          />
        </div>
      </div>

      {/* =================================closing line starts here====================== */}
      <div className="py-10 my-60 lg:my-0 lg:my10 lg:px-44 lg:pb-44 flex flex-col justify-center items-center  ">
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-2xl lg:text-5xl mb-5 font-bold ">
            Feel the Difference
          </h1>
          <p className="text-xl">Join today to stay ahead in your career.</p>
        </div>
        <div className="mt-7">
          <Link to="/usersignup">
            <Button
              className={`bg-gradient-to-r from-sky-400 to-indigo-600 h-12 text-white text-sm font-semibold px-6 rounded-lg hover:from-indigo-600 hover:to-sky-400 transition-colors duration-300 hover:text-gray-100 ${
                token ? "cursor-not-allowed" : ""
              }`}
              disabled={token}
            >
              Join Now
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
